import { GRIDVIEWICON, LISTVIEWICON } from "../Utils/icons";

export default function ViewToggle(props) {
  /* 1 for list 2 for grid */
  const listViewHandler = () => {
    props.listViewHandler();
  };
  const gridViewHandler = () => {
    props.gridViewHandler();
  };
  return (
    <div className="pageToolBar">
      <ul>
        <li onClick={listViewHandler}>
          <i>
            <LISTVIEWICON />
          </i>
        </li>
        <li onClick={gridViewHandler}>
          <i>
            <GRIDVIEWICON />
          </i>
        </li>
      </ul>
    </div>
  );
}
